import { DropzoneAreaField as BaseDropzoneAreaField } from '@wyz/ui';
import * as React from 'react';
import { useManageResources, useManageTenantResources } from '~/common/api';
import { useI18n } from '~/common/context';

type DropzoneAreaFieldProps = React.ComponentProps<
  typeof BaseDropzoneAreaField
>;

type Props = Omit<
  DropzoneAreaFieldProps,
  | 'translate'
  | 'isUploading'
  | 'createFunction'
  | 'resourceReader'
  | 'translations'
> & { scope?: 'TENANT' | 'COMMON' };

function DropzoneAreaField({ scope = 'COMMON', ...props }: Props) {
  const { t } = useI18n();
  const manageResource = useManageResources();
  const manageTenantResources = useManageTenantResources();
  const SCOPE_PROPS = {
    TENANT: manageTenantResources,
    COMMON: manageResource,
  } as const;

  return (
    <BaseDropzoneAreaField
      {...props}
      translate={t}
      isUploading={SCOPE_PROPS[scope].mutation.isLoading}
      createFunction={SCOPE_PROPS[scope].handlers.uploadMany}
      resourceReader={SCOPE_PROPS[scope].handlers.getDownloadablePath}
      translations={{
        dropFilesMessage: t('app.common.file_input.drop_files_message'),
      }}
    />
  );
}

export default DropzoneAreaField;
